import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getRemoteConfig } from 'firebase/remote-config';

import { firebaseConfig } from 'config/constants';
import { getFunctions } from "firebase/functions";

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const remoteConfig = getRemoteConfig(app);

// Remote Config settings
// Set to 0 for development to always fetch fresh values (no cache)
// In production, consider increasing to 3600000 (1 hour) for performance
remoteConfig.settings = {
  minimumFetchIntervalMillis: 0, // No cache - always fetch fresh values
  fetchTimeoutMillis: 60000, // 60 seconds
};

// Default values for remote config
remoteConfig.defaultConfig = {
  fp_documents_onboarding: false,
};

export default auth; // Default export
export { app, db, functions, remoteConfig }; // Named exports
